import { OneTimePurchaseBookingStatus } from '@platform-frontend/checkout-drop-in';
import { AssetDetails } from './asset-details';

export interface OneTimePurchaseDetails<T = OneTimePurchaseBookingStatus> extends AssetDetails {
  endOfTerm: Date | null;
  bookingStatus: T;
}
